import * as React from 'react';
import { Button, UIText1 } from '@cian/ui-kit';

import * as styles from './CallButton.css';

interface ICallButtonFieldProps {
  phone: string;
  isOpen: boolean;
  disabled?: boolean;
  onClick(e: React.SyntheticEvent<HTMLButtonElement>): void;
  buttonText?: number | string;
  buttonIcon?: React.ReactElement<any>;
}

export const CallButton: React.FC<ICallButtonFieldProps> = ({
  phone,
  isOpen,
  onClick,
  disabled = false,
  buttonText = 'Показать телефон',
  buttonIcon,
}) => {
  if (isOpen) {
    return (
      <div className={styles['phone']}>
        <UIText1 color="text-primary-default" fontWeight="700">
          {phone}
        </UIText1>
      </div>
    );
  }

  return (
    <Button disabled={disabled} size="XS" theme="fill_primary" onClick={onClick} beforeIcon={buttonIcon}>
      {buttonText}
    </Button>
  );
};
